import { gql } from '@apollo/client';

const CREATE_GROUP_COUPON = gql`
  mutation createGroupCoupon($groupCoupon: GroupCouponCreateInput!) {
    createGroupCoupon(groupCoupon: $groupCoupon) {
      success
      message
      groupCoupon { 
        id
      }  
    }
  }
`;

export { CREATE_GROUP_COUPON }
